import RequestManager from "../../../requests/RequestManager";
import PlayerTimeWindowsTask from "../../../requests/tasks/sports/playerTimeWindowsTask";
import LiveEventsTask from "../../../requests/tasks/sports/liveEventsTask";
import LiveMatchActionsTask from "../../../requests/tasks/sports/liveMatchActionsTask";
import logger from 'src/utils/logger/logger';
export const getPlayerTimeWindows = async () => {
    const playerTimeWindowsTask = new PlayerTimeWindowsTask();
    try {
        const response = await RequestManager.addRequest(playerTimeWindowsTask);
        if(!response) return null;
        return response
    } catch (error) {
        logger.error('Error fetching matches:', error);
        throw error
    }
}

export const getLiveEvents = async (matchId, options = {}) => {

    const liveEventsTask = new LiveEventsTask(matchId, options);
    try {
        const response = await RequestManager.addRequest(liveEventsTask);
        if(!response) return null;
        return response
    } catch (error) {
        logger.error('Error fetching live events:', error);
        throw error
    }
}

export const getLiveMatchActions = async (matchId) => {
    const liveMatchActionsTask = new LiveMatchActionsTask(matchId);
    try {
        const response = await RequestManager.addRequest(liveMatchActionsTask);
        if(!response) return null;
        return response
    } catch (error) {
        logger.error('Error fetching matches:', error);
        throw error
    }
}



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/services/getPolling.js